import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedCrossedOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.273 1 1 2.273 3.727 5c-2.522 1.16-3.1 3.584-2.52 8.5C2.188 21.813 3.537 23 12 23c4.178 0 6.622-.29 8.144-1.583l1.586 1.586 1.273-1.273zM5.12 6.394c-.596.184-1.004.401-1.29.635-.807.657-1.334 2.045-.836 6.26.243 2.062.497 3.556.842 4.67.338 1.09.724 1.682 1.15 2.057.428.377 1.072.69 2.215.897 1.163.211 2.698.287 4.798.287s3.635-.076 4.798-.287c1.018-.184 1.64-.453 2.066-.776L12.5 13.773v.627h-7v-1.8h5.827l-1.7-1.7H5V9.1h2.827z"
                    fill="currentColor"
                />
                <path
                    d="M12 2.2c-2.196 0-4.1.063-5.7.28l-.87-.868C6.859 1.124 8.987 1 12 1c5.042 0 7.606.346 8.556 2.167-.762-.294-1.593-.492-2.468-.63C16.41 2.274 14.376 2.2 12 2.2"
                    fill="currentColor"
                />
                <path
                    d="M21.98 18.161c.344-1.227.588-2.757.813-4.661C23.774 5.188 21.443 4 12 4c-1.537 0-2.885.031-4.061.12l1.713 1.713A73 73 0 0 1 12 5.8c2.346 0 4.144.075 5.528.293 1.393.22 2.176.557 2.641.936.807.657 1.334 2.045.836 6.26-.16 1.354-.324 2.464-.516 3.382z"
                    fill="currentColor"
                />
                <path d="M19 10.9h-4.281l-1.8-1.8H19z" fill="currentColor" />
            </g>
        </svg>
    )
);
CardLinesStackedCrossedOutlinedSize24Glyph.displayName = 'CardLinesStackedCrossedOutlinedSize24Glyph';
